module.exports = [
  'Promise',
  function (Promise) {
    return {
      getAddress: Promise.wrapper('oab:getDirectories', { recursive: false }),
      getContact: Promise.wrapper('oab:listEx'),
      searchContact: Promise.wrapper('oab:autoMatch'),
      getAllGroups: Promise.wrapper('pab:getAllGroups'),
      listPersonContacts: Promise.wrapper('pab:searchContacts'),
      createContacts: Promise.wrapper('pab:createContacts'),
      updateContacts: Promise.wrapper('pab:updateContacts'),
      updateAllGroups: Promise.wrapper('pab:updateAllGroups'),
      getPersonalContact: Promise.wrapper('pab:getContacts'),
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/contactListService.js